import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import ToggleActveFileButton from '../toggleActveFileButton.container';

const styles = () => ({
  cell: {
    width: '100%',
  },
});

const SessionTableRowComponent = ({ sessionId, row, classes }) => (
  <TableRow
    hover
    tabIndex={-1}
  >
    <TableCell className={classes.cell}>{row.filename}</TableCell>
    <TableCell >
      <ToggleActveFileButton
        sessionId={sessionId}
        fileId={row.id}
        label="Restore"
        icon="restore"
        setActive
      />
    </TableCell>
  </TableRow>
);

SessionTableRowComponent.propTypes = {
  sessionId: PropTypes.string.isRequired,
  row: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    lastModified: PropTypes.number,
    savedByUser: PropTypes.bool,
  }).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(SessionTableRowComponent);
